import type { KenjossetChrome } from "@/components/kenjosset/types"

interface FooterProps {
  chrome: KenjossetChrome
}

const linkClass = "text-sm leading-6 text-primary hover:text-contrast"

// Faithful React port of kenjosset/common/_footer (+ SocialLinks::Component).
// The social icons keep `text-constrast` verbatim: it is a typo in the
// component's default colour argument, matches no Tailwind class, and so leaves
// the icons inheriting their colour — reproducing it keeps the footer identical.
// The dead `href="#"` legal links are intentional: same as the Slim version.
export default function Footer({ chrome }: FooterProps) {
  const { paths, social } = chrome
  const year = new Date().getFullYear()

  return (
    <footer className="mt-3 bg-light">
      <div className="px-6 py-3 mx-auto overflow-hidden max-w-7xl sm:py-12 lg:px-8">
        <nav className="-mb-6 columns-2 sm:flex sm:justify-center sm:space-x-12" aria-label="Footer">
          <div className="pb-6 text-center">
            <a href="#" className={linkClass}>
              CGV
            </a>
          </div>
          <div className="pb-6 text-center">
            <a href={paths.contact} className={linkClass}>
              Contact
            </a>
          </div>
          <div className="pb-6 text-center">
            <a href={paths.store} className={linkClass}>
              Boutique
            </a>
          </div>
          <div className="pb-6 text-center">
            <a href="#" className={linkClass}>
              Mentions légales
            </a>
          </div>
          <div className="pb-6 text-center">
            <a href="#" className={linkClass}>
              Confidentialité
            </a>
          </div>
          <div className="pb-6 text-center">
            <a href="#" className={linkClass}>
              Cookies
            </a>
          </div>
          <div className="pb-6 text-center">
            <a href="#" className={linkClass}>
              Plan du site
            </a>
          </div>
        </nav>

        <div className="flex justify-center mt-10 space-x-10">
          <div className="flex gap-4 text-2xl items-center">
            {social.instagram && (
              <a href={social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram">
                <i className="fa-brands fa-instagram hover:text-primary text-constrast" />
              </a>
            )}
            {social.facebook && (
              <a href={social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook">
                <i className="fa-brands fa-facebook hover:text-primary text-constrast" />
              </a>
            )}
          </div>
        </div>

        <p className="mt-3 text-xs leading-5 text-center text-midgray">
          © Ken Josset {year} - All rights reserved
        </p>
      </div>
    </footer>
  )
}
